import axios from "axios";
import { backendDomain } from "../../paths";

const instance = axios.create({
  // baseURL: "http://192.168.1.13:3001/api/v1/bidder/",
  // baseURL: "https://www.mockauctioner.cloud/api/v1/bidder/",
  baseURL: backendDomain + "/api/v1/bidder/",
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "content-type": "application/json;charset=utf-8",
    Authorization: localStorage.getItem("bidderToken"),
  },
});

export default instance;
